import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Reveal } from "@/components/landing/Reveal";

export function FinalCta() {
  return (
    <section className="bg-[#12100C] py-20 md:py-28" data-testid="landing-final-cta">
      <div className="max-w-3xl mx-auto px-6 md:px-10 text-center">
        <Reveal>
          <h2 className="font-display text-3xl md:text-5xl text-amtm-bg mb-4 leading-tight">
            Be the reason one of them recovers.
          </h2>
          <p className="text-amtm-bg/70 mb-9 max-w-xl mx-auto">
            Case donations directly fund that animal's treatment.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Button
              asChild
              size="lg"
              className="rounded-full h-[52px] px-8 bg-amtm-teal text-white hover:bg-amtm-tealHover font-semibold w-full sm:w-auto"
              data-testid="landing-final-cta-see-animals"
            >
              <Link to="/cases">
                <Heart className="h-5 w-5 mr-2" /> Animals in Our Care
              </Link>
            </Button>
            <Button
              asChild
              size="lg"
              variant="outline"
              className="rounded-full h-[52px] px-8 bg-transparent border-amtm-bg/40 text-amtm-bg hover:bg-amtm-bg/10 hover:text-amtm-bg font-semibold w-full sm:w-auto"
              data-testid="landing-final-cta-donate"
            >
              <Link to="/cases">Donate</Link>
            </Button>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
